export default "__VITE_ASSET__B2k$Fmnf__"